import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ActionSheetController, AlertController, LoadingController, MenuController, ModalController, NavParams, PopoverController } from '@ionic/angular';
import { ComFilterLeadsComponent } from '../com-filter-leads/com-filter-leads.component';
import { UtilService } from '../services/util/util.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-leads-update-status',
  templateUrl: './leads-update-status.page.html',
  styleUrls: ['./leads-update-status.page.scss'],
})
export class LeadsUpdateStatusPage implements OnInit {

  baseUrl: any = '';
  provision_key: any = '';
  client_id: any = '';
  client_secret: any = '';
  grant_type: any = '';
  authUrl: any = '';

  load: boolean = false;
  button: boolean = false;
  token: any;
  user: any;
  hasil: any;
  hsl: any;
  kw: any;

  selct: any = '';
  keterangan: any = '';

  
  constructor(
    public popoverController: PopoverController,
    public modalController: ModalController,
    public menuCtrl: MenuController,
    public route: Router,
    public http: HttpClient,
    public loadingctrl: LoadingController,
    public alertctrl: AlertController,
    public util: UtilService,
    public activatedRoute: ActivatedRoute,
    public actionSheetController: ActionSheetController,
    public navParams: NavParams
  ) {
    this.baseUrl = environment.restURL.baseUrl;
    this.provision_key = environment.restURL.provision_key;
    this.client_id = environment.restURL.client_id;
    this.client_secret = environment.restURL.client_secret;
    this.grant_type = environment.restURL.grant_type;
    this.authUrl = environment.restURL.authUrl;

    this.kw = this.navParams.data.id;
    console.log('KW', this.kw);
  }

  ngOnInit() {
    this.user = JSON.parse(localStorage.getItem('user') || '');
    this.token = localStorage.getItem('usertoken') || '';
  }

  batal(){
    this.modalController.dismiss();
  }

  konf(){
    if (this.selct == '') {
      this.util.shoNotification('Status Wajib Diisi', 'danger', 'bottom');
      return false;
    } else if (this.keterangan == ''){
      this.util.shoNotification('Keterangan Wajib Diisi', 'danger', 'bottom');
    }else {
      let form = JSON.stringify({
        lead_id:this.kw,
        status:this.selct,
        keterangan:this.keterangan
      });
      let hd = {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + this.token
      };
      console.log('FORM',form);
      console.log('hd',hd);
      this.button = true;
      this.http.post(this.baseUrl + 'backoffice/sales/leads/update/status',form, {headers: hd})
      .subscribe(( data ) => {
        this.hasil = data;
        console.log('hasil',this.hasil);
        if(this.hasil.error == 0){
          this.button = false;
          this.batal();
          this.util.showToast(this.hasil.message, 'success', 'bottom');
        }else{ 
          this.button = false;
          this.util.showToast(this.hasil.message, 'danger', 'bottom');
        }
        },(error) => {
          this.button = false;
          this.util.showToast(error.error.message, 'danger', 'bottom');
          console.log('error',error)
        });
    }
  }

  pilih(p){
    console.log(p);
    if(this.selct == ''){
      this.selct = p;
    } else if (this.selct == p){
      this.selct = '';
    } else {
      this.selct = p;
    }
    console.log('selct', this.selct);
  }

}
